var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`edu-icon ${_vm.icon}`,style:(_vm.getPosition())})
}
var staticRenderFns = []

export { render, staticRenderFns }